import axios from 'axios';
import { captureException } from '@sentry/react';

import {
  SET_MAP_POINTS,
  SET_MAP_POINTS_IS_FETCHED,
  SET_MAP_POINTS_SEARCH_QUERY,
} from './constants';

export const getPointsByZoneSlug = (pageSlug, url) => (dispatch) => {
  axios({
    method: 'get',
    url,
    responseType: 'json',
    params: {
      slug: pageSlug,
    },
  })
    .then((response) => {
      const responseData = response.data || {};
      /** TODO: remove mapping when [SHOP-3951] is done */
      if (responseData.isSucceeded) {
        const points = (responseData.data || {}).points || [];
        const convertBadges = (payments) => {
          const hasTradeIn = (payments || []).filter((payment) => payment.slug === 'trade-in');
          if (hasTradeIn.length > 0) {
            return 'Trade-in';
          }
          return null;
        };

        const mappedPoints = points.map((point) => ({
          address: point.address,
          city: point.city,
          code: point.code,
          id: point.id,
          latitude: point.latitude,
          longitude: point.longitude,
          name: point.name,
          opening: point.opening,
          telephone: point.telephone,
          title: point.title,
          subway:
            point.nearestSubway ?
              {
                color: point.nearestSubway.lineColor,
                name: point.nearestSubway.name,
                slug: point.nearestSubway.slug,
              }
            : null,
          badge: convertBadges(point.paymentMethods),
        }));

        dispatch({
          type: SET_MAP_POINTS,
          payload: mappedPoints,
        });
        dispatch({
          type: SET_MAP_POINTS_IS_FETCHED,
          payload: true,
        });
      }
    })
    .catch(captureException);
};

export const setPointsSearchQuery = (value) => ({
  type: SET_MAP_POINTS_SEARCH_QUERY,
  payload: value,
});
